import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { useKitchenStore } from '../kitchenStore'
import { BottomNav } from './BottomNav'
import { Toaster } from './ui/Toast'

/* Mobile shell owns 100dvh; the bottom navigation sits in flow and is the
   sole owner of the bottom safe-area inset. On desktop the app presents as
   a centered installable-width column. */
export function AppShell() {
  const kitchenName = useKitchenStore((state) => state.name)

  useEffect(() => {
    document.title =
      kitchenName && kitchenName !== 'Your kitchen'
        ? `${kitchenName} · JDH`
        : 'JDH'
  }, [kitchenName])

  return (
    <div className="mx-auto flex h-dvh w-full flex-col bg-canvas md:my-6 md:h-[calc(100dvh-3rem)] md:max-w-105 md:overflow-hidden md:rounded-sheet md:border md:border-line/70 md:shadow-overlay">
      <main className="page-scroll flex min-h-0 flex-1 flex-col overflow-y-auto">
        <Outlet />
      </main>
      <BottomNav />
      <Toaster />
    </div>
  )
}
